import { CarouselItemId } from '@homex/se-widget-flow-types';
import { useSelector } from 'react-redux';

import { CarouselItemCustomerLocationsBottomBase } from 'components/CarouselItemCustomerLocationsBottomBase';
import { CustomerLocationCarouselItem, IState } from 'typings';
import { tryGetFlowCarouselItem } from 'utils/tryGetFlowCarouselItem';

export const CAROUSEL_ITEM_ID = CarouselItemId.CustomerLocations;

export const CarouselItemCustomerLocationsBottom = () => {
  const { flowCarouselItem, schedulePreferenceEnabled } = useSelector(
    (state: IState) => ({
      flowCarouselItem: tryGetFlowCarouselItem<CustomerLocationCarouselItem>(
        state.client.flow,
        CAROUSEL_ITEM_ID,
      ),
      schedulePreferenceEnabled: state.client.schedulePreferenceEnabled,
    }),
  );

  let existingLocationDestinationId;
  let previousCustomerDestinationId;
  let nextDestinationId;

  if (flowCarouselItem) {
    existingLocationDestinationId =
      flowCarouselItem.options.destinations.existingLocation;
    previousCustomerDestinationId =
      flowCarouselItem.options.destinations.previousCustomer;
    nextDestinationId = flowCarouselItem.options.destinations.next;
  } else {
    existingLocationDestinationId = schedulePreferenceEnabled
      ? CarouselItemId.SchedulePreference
      : CarouselItemId.ScheduleCalendarRepair;
    previousCustomerDestinationId = CarouselItemId.RepairContactInfo;
    nextDestinationId = CarouselItemId.ServiceAreaRepair;
  }

  return (
    <CarouselItemCustomerLocationsBottomBase
      existingLocationDestinationId={existingLocationDestinationId}
      nextDestinationId={nextDestinationId}
      parentCarouselItemId={CAROUSEL_ITEM_ID}
      previousCustomerDestinationId={previousCustomerDestinationId}
    />
  );
};
